import styled from 'styled-components';
import { WhiteSectionCss } from '../AllContributorsDoraDashboard.style';

export const StyledCycleTimeWrapper = styled.div`
  ${WhiteSectionCss};
`;
